import { ReactNode, useEffect } from "react";
import { setGlobalCustomDimension } from "@leafly-com/web-utils";
import cx from "classnames";
import Head from "next/head";
import { useDispatch, useSelector } from "react-redux";

import { useIsJaneCheckoutEnabled } from "hooks/useIsJaneCheckoutEnabled";
import { getCart, getTotalCartQuantity } from "redux/selectors/cart";
import { getCartDispensaryData } from "redux/selectors/cartDispensary";
import { setSessionStorage } from "utils/sessionStorage";

const CheckoutLayout = ({
  children,
  className,
  indexInSearchEngines,
  isAndroidNative,
  menuType,
  referrer,
}: {
  children?: ReactNode;
  className?: string;
  indexInSearchEngines?: boolean;
  isAndroidNative?: boolean;
  menuType?: string | null;
  referrer: string | null;
}) => {
  const dispatch = useDispatch();

  const dispensary = useSelector(getCartDispensaryData);
  const cart = useSelector(getCart);
  const totalCartQuantity = useSelector(getTotalCartQuantity);
  const isJaneCheckoutEnabled = useIsJaneCheckoutEnabled();

  const leaflyMenu =
    dispensary && dispensary.slug ? `/dispensary-info/${dispensary.slug}` : "/";

  useEffect(() => {
    if (isAndroidNative) {
      setSessionStorage("isAndroidNative", "true");
    }
  }, [isAndroidNative]);

  useEffect(() => {
    setGlobalCustomDimension("dispensaryId", dispensary?.id);
    setGlobalCustomDimension("cartId", cart?.data?.id);
    setGlobalCustomDimension("sessionId", cart?.data?.sessionId);
    setGlobalCustomDimension("userId", cart?.data?.userId);
    setGlobalCustomDimension("janeCheckoutEnabled", isJaneCheckoutEnabled);

    if (referrer) {
      setSessionStorage("referrer", referrer);
    }
    dispatch({
      menuLink: referrer || leaflyMenu,
      type: "cartDispensary/setMenuLink",
    });

    if (menuType) {
      setSessionStorage("menuType", menuType);
    }
  }, [totalCartQuantity, menuType]);

  return (
    <>
      <Head>
        <title>My Orders | Leafly</title>
        {!indexInSearchEngines && <meta name="robots" content="noindex" />}
      </Head>
      <div className={cx("bg-leafly-white", className)}>{children}</div>
    </>
  );
};

export default CheckoutLayout;
